import React from 'react'
import AuthService from '../utils/AuthService'
import URLService from '../utils/URLService'
import { Redirect, Route } from 'react-router-dom'

const PrivateRoute = ({ component: Component, ...rest }) => {

  // Add your own authentication on the below line.
  var Auth = new AuthService()
  const isLoggedIn = Auth.loggedIn()
  this.URLService = new URLService()
  var url = this.URLService.getUrl()

  return (
    <Route
      {...rest}
      render={props =>

        isLoggedIn ? (
          <Component {...props} />
        ) : (
          window.location.href =  "../login"
        )
      }
    />
  )
}

export default PrivateRoute



// WEBPACK FOOTER //
// ./src/Components/PrivateRoute.js